import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-labels',
  templateUrl: './card-labels.component.html',
  styleUrls: ['./card-labels.component.scss']
})
export class CardLabelsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
